import React from 'react';
import styled from 'styled-components';
import CellContainer from '../CellContainer';
import Tooltip from '../../Tooltip';
import { I18n } from 'react-redux-i18n';
import Icon from '../../Icon';

const IconWithoutForwardProps = ({
  hide: _hide,
  filled: _filled,
  ...otherProps
}) => <Icon {...otherProps} />;

const MichelinStar = styled(IconWithoutForwardProps).attrs(() => ({
  icon: 'michelinStarIcon'
}))`
  color: ${(props) => (props.filled ? '#D3072B' : '#adb5bdbf')};
  stroke-width: 0.3;
  display: flex;
  stroke: ${(props) => (props.filled ? '#D3072B' : '#adb5bdbf')};
  visibility: ${(props) => (props.hide ? 'hidden' : 'visible')};
  :not(:last-child) {
    margin-right: 6px;
  }
`;

const MichelinGreenStar = styled(IconWithoutForwardProps).attrs(() => ({
  icon: 'michelinGreenStarIcon'
}))`
  color: ${(props) => (props.filled ? '#649F42' : '#adb5bdbf')};
  stroke-width: 0.3;
  display: flex;
  stroke: ${(props) => (props.filled ? '#649F42' : '#adb5bdbf')};
  visibility: ${(props) => (props.hide ? 'hidden' : 'visible')};
`;

const ClassicStar = styled.div`
  font-size: 14px;
  color: ${(props) => (props.filled ? '#f5a623' : 'rgba(173, 181, 189, 0.2)')};
  visibility: ${(props) => (props.hide ? 'hidden' : 'visible')};
  :not(:last-child) {
    margin-right: 6px;
  }
`;

const RestaurantStars = ({ stars, greenStar }) => {
  const output = [];
  for (let i = 0; i < stars; i++) {
    output.push(<MichelinStar key={i} filled={true} />);
  }
  if (greenStar) {
    output.push(
      <MichelinGreenStar key={stars + 1} filled={true} hide={false} />
    );
  }

  return output;
};

const WineStars = ({ stars, hideEmpty }) => {
  const totalStars = 5;
  return Array.from({ length: totalStars }, (_, index) => (
    <ClassicStar
      key={index}
      filled={stars > index}
      hide={hideEmpty && stars <= index}
    >
      ★
    </ClassicStar>
  ));
};

const QualityStars = ({ value, hideEmpty }) => {
  if (!value.stars && !value.michelin_stars && !value.michelin_green_star) {
    return null;
  }

  const tooltipContent =
    value.type === 'OFF'
      ? I18n.t('cellQualityWineShop')
      : I18n.t('cellQualityRestaurant');

  const Stars =
    value.type === 'OFF' ? (
      <WineStars stars={Number(value.stars) || 0} hideEmpty={hideEmpty} />
    ) : (
      <RestaurantStars
        stars={value.michelin_stars}
        greenStar={value.michelin_green_star}
      />
    );

  return (
    <Tooltip placement="top" noCursor content={<div>{tooltipContent}</div>}>
      <div className="qualityStarsContainer">{Stars}</div>
    </Tooltip>
  );
};

const CellQualityDiv = styled.div`
  font-size: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  p {
    color: #2b3d54;
    white-space: normal;
  }

  > div {
    width: inherit;
  }

  .qualityStarsContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
`;

const CellQuality = ({ value, hideEmpty, ...otherProps }) => {
  return (
    <CellContainer {...otherProps}>
      <CellQualityDiv>
        {value.ws_award && <p>{value.ws_award}</p>}
        <QualityStars value={value} hideEmpty={hideEmpty} />
      </CellQualityDiv>
    </CellContainer>
  );
};

export default CellQuality;
